import React, { useState } from "react";
import { Button } from "react-bootstrap";
import SendEmailAttach from "./SendEmailAttach";

const AdditionalDocumentEmailModal = ({
  defaultContent,
  handleSubmit,
  setFiles,
  files,
  toggleCancel,
  handleEditorChange,
  editorState,
  mailData,
  type,
  handleMail,
}) => {
  const [additionalDocument, setAdditionalDocument] = useState(null);
  return (
    <>
      {additionalDocument === null && (
        <>
          <div className="modal-body">
            Do you want to attach any additional document(s) to the email?
          </div>
          <div className="modal-footer">
            <Button
              type="submit"
              className="btn btn-primary"
              data-dismiss="modal"
              onClick={() => {
                setAdditionalDocument(true);
              }}
            >
              Yes
            </Button>
            <Button
              type="Button"
              className="btn btn-secondary"
              onClick={async () => {
                if (type === "payment_schedule") {
                  await handleMail();
                } else {
                  setAdditionalDocument(false);
                }
              }}
            >
              No
            </Button>
          </div>
        </>
      )}
      {additionalDocument === true && (
        <SendEmailAttach
          handleSubmit={handleSubmit}
          setFiles={setFiles}
          files={files}
          toggleCancel={toggleCancel}
          handleEditorChange={handleEditorChange}
          editorState={editorState}
          mailData={mailData}
          type={type}
        />
      )}
      {additionalDocument === false && type !== "payment_schedule" && (
        <>{defaultContent}</>
      )}
    </>
  );
};

export default AdditionalDocumentEmailModal;
